import React from 'react';
import { motion } from 'framer-motion';
export function MathProofSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8
  }} className="my-16" data-id="element-125">
      <div className="bg-white/50 border-t-2 border-[#D4652A] p-6 md:p-8 rounded-sm shadow-sm" data-id="element-126">
        <h3 className="text-lg font-bold text-[#1B2A4A] uppercase tracking-wider mb-6 text-center md:text-left" data-id="element-127">
          The Math Behind the Mistake
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-128">
          <div className="space-y-2" data-id="element-129">
            <p className="text-[#1B2A4A]/70 text-sm font-bold uppercase" data-id="element-130">
              Claimed at 62
            </p>
            <p className="text-2xl font-bold text-[#1B2A4A]" data-id="element-131">
              $1,800
              <span className="text-base font-normal text-[#1B2A4A]/60" data-id="element-132">
                /mo
              </span>
            </p>
            <p className="text-lg text-[#1B2A4A] border-t border-[#1B2A4A]/10 pt-2 mt-2" data-id="element-133">
              $432,000{' '}
              <span className="text-sm text-[#1B2A4A]/60" data-id="element-134">over 20 years</span>
            </p>
          </div>

          <div className="space-y-2" data-id="element-135">
            <p className="text-[#D4652A] text-sm font-bold uppercase" data-id="element-136">
              Corrected to FRA Amount
            </p>
            <p className="text-2xl font-bold text-[#1B2A4A]" data-id="element-137">
              $2,375
              <span className="text-base font-normal text-[#1B2A4A]/60" data-id="element-138">
                /mo
              </span>
            </p>
            <p className="text-lg text-[#1B2A4A] border-t border-[#1B2A4A]/10 pt-2 mt-2" data-id="element-139">
              $570,000{' '}
              <span className="text-sm text-[#1B2A4A]/60" data-id="element-140">over 20 years</span>
            </p>
          </div>
        </div>

        <div className="text-center md:text-left space-y-4" data-id="element-141">
          <p className="text-xl md:text-2xl font-bold text-[#1B2A4A]" data-id="element-142">
            The difference: <span className="text-[#D4652A]" data-id="element-143">$138,000</span>.
          </p>
          <p className="text-lg text-[#1B2A4A] italic" data-id="element-144">
            That&apos;s not a rounding error. That&apos;s a second retirement.
          </p>
          <p className="text-base text-[#1B2A4A]/70 border-t border-[#1B2A4A]/10 pt-4 mt-4" data-id="element-145">
            And that&apos;s before we factor in the cost-of-living adjustments
            that compound on the HIGHER base amount every single year.
          </p>
        </div>
      </div>
    </motion.section>;
}